export default {
  subtitle: "Balance",
  path: "bank_account_balance",
  paragraph: "To check the balance of any of your internal accounts in that moment, you can use the following endpoint:",
  request:  {
    method: "GET",
    endpoint: "/bank_accounts/:id/balance",
    responses: {
      "data": {
        "debit_value": "65078.64",
        "debit_transactions": 26,
        "currency": "BRL",
        "credit_value": "143078.64",
        "credit_transactions": 8,
        "balance": "78000.00"
      }
    }
  },
  pathPayload: [
    {
      name: "id",
      type: "string",
      required: true,
      description: "Your internal bank account ID"
    }
  ]
}



// WEBPACK FOOTER //
// ./src/components/documentation/data/BankAccount/InternalBankAccountBalance.js